export enum HourStatus {
  Normal = 'normal',
  Overnight = 'overnight',
  Multiple = 'multiple',
  Closed = 'closed',
}

export interface TradingHour {
  date: string
  openingTime: string
  closingTime: string
  closed: boolean
  description: string
  hourStatus: HourStatus
}

export interface Description {
  readonly description: string
  isColored: boolean
}

export interface ParsedBannerOpeningHour {
  hours: string
  text: Description
}

export interface ParsedOpeningHour {
  hours: string[]
  text: Description
  day: string
}

export interface ParsedOpeningHourWithStatus extends ParsedOpeningHour {
  status: HourStatus
}

export interface CentreTradingSchedule {
  tradingHours: TradingHour[]
}

export interface StoreTradingSchedule {
  tradingHours: TradingHour[]
  isStoreCentreLinked: boolean
}
